import { QueryConfig } from "store/utils/query-config";

export const newsfeedItemDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
